import QuizWrapper from './QuizWrapper';

export default QuizWrapper;
